import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            redirect: "/devicesHome",
        },
        {
            path: "/devicesHome",
            name: "devicesHome",
            component: () => import("../views/devicesHome.vue"),
        },
        {
            path: "/devicesList",
            name: "devicesList",
            component: () => import("../views/devicesList.vue"),
        },
        {
            path: "/devicesDetails",
            name: "devicesDetails",
            component: () => import("../views/devicesDetails.vue"),
        },
        {
            path: "/filePreview",
            name: "filePreview",
            component: () => import("../views/filePreview.vue"),
        },
        {
            path: "/videoPlay",
            name: "videoPlay",
            component: () => import("../views/videoPlay.vue"),
        },
        {
            path: "/videoDownload",
            name: "videoDownload",
            component: () => import("../views/videoDownload.vue"),
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js